import { useCreativeLibrary } from '../../demo/selectors'
import { useDemoStore } from '../../demo/store'
import { Button, CreativeCard, EmptyState } from '../../ui'
import styles from './ComplianceAlerts.module.css'

interface CreativeSwapPickerProps {
  campaignId: string
  currentCreativeId: string
  unusedOnly?: boolean
  onSelect: (creativeId: string) => void
  onCancel: () => void
}

export function CreativeSwapPicker({
  campaignId,
  currentCreativeId,
  unusedOnly = false,
  onSelect,
  onCancel,
}: CreativeSwapPickerProps) {
  const productId = useDemoStore((state) => state.campaigns.find((campaign) => campaign.id === campaignId)?.productId)
  const library = useCreativeLibrary({ productId })
  const candidates = library.filter((creative) => (
    creative.id !== currentCreativeId
    && creative.compliance?.level !== 'violation'
    && (!unusedOnly || creative.usedByAds === 0)
  ))

  return (
    <section className={styles.picker} aria-label={unusedOnly ? '选择未使用素材' : '选择替换素材'}>
      <div className={styles.pickerHead}>
        <div>
          <h3>选择替换素材</h3>
          <p>{unusedOnly ? '只显示该商品下未使用的素材' : '只显示同商品、未违规的其他素材'}</p>
        </div>
        <Button variant="link" onClick={onCancel}>取消</Button>
      </div>
      {candidates.length > 0 ? (
        <div className={styles.pickerGrid} role="radiogroup">
          {candidates.map((creative) => (
            <CreativeCard
              key={creative.id}
              className={styles.pickerCard}
              role="radio"
              aria-checked="false"
              tabIndex={0}
              name={creative.name}
              kind={creative.kind}
              cover={creative.cover}
              dataUrl={creative.dataUrl}
              duration={creative.duration}
              source={creative.source}
              kol={creative.kol}
              usedByAds={creative.usedByAds}
              compliance={creative.compliance}
              onClick={() => onSelect(creative.id)}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault()
                  onSelect(creative.id)
                }
              }}
            />
          ))}
        </div>
      ) : (
        <EmptyState className={styles.compactEmpty} icon="inbox" title="没有可替换的素材" text="当前商品下没有符合条件的候选素材" />
      )}
    </section>
  )
}
